/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Pickup_To_Shipping_Requires_RerateInputs */

const en_orders_carrier_pickup_to_shipping_requires_rerate = /** @type {(inputs: Orders_Carrier_Pickup_To_Shipping_Requires_RerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup to shipping requires Change + Auto-Rerate.`)
};

const es_orders_carrier_pickup_to_shipping_requires_rerate = /** @type {(inputs: Orders_Carrier_Pickup_To_Shipping_Requires_RerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar de pickup a envio requiere Cambiar + Auto-rerate.`)
};

/**
* | output |
* | --- |
* | "Pickup to shipping requires Change + Auto-Rerate." |
*
* @param {Orders_Carrier_Pickup_To_Shipping_Requires_RerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_pickup_to_shipping_requires_rerate = /** @type {((inputs?: Orders_Carrier_Pickup_To_Shipping_Requires_RerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Pickup_To_Shipping_Requires_RerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_pickup_to_shipping_requires_rerate(inputs)
	return es_orders_carrier_pickup_to_shipping_requires_rerate(inputs)
});